'use client';
import { useState } from 'react';
import Button from '@/components/ui/Button';
import Modal from './Modal';

function ContactForm(props) {
  const { dict } = props;

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });

  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState(false);
  const [isSuccessSubmitted, setIsSuccessSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      setError(true);
      return;
    }

    try {
      // TODO: replace with the real Tekhnika i Hadzhety endpoint
      await fetch('/send_email.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
        }),
      });
    } catch (error) {
      console.error('Error sending form data:', error);
      return;
    }

    setIsSuccessSubmitted(true);

    setFormData({ name: '', phone: '', email: '', message: '' });
    setError(false);
    setIsChecked(false);
  };

  const fieldBase =
    'w-full bg-white/[0.04] border border-white/15 rounded-lg px-6 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-accent focus:bg-white/[0.06] transition-colors';

  return (
    <>
      <Modal
        isOpen={isSuccessSubmitted}
        onClose={() => setIsSuccessSubmitted(false)}
      >
        <div className='flex flex-col items-center justify-center space-y-4'>
          <svg
            width='40'
            height='40'
            viewBox='0 0 40 40'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z'
              stroke='#0066FF'
              strokeWidth='3'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M15 19.9998L18.3333 23.3332L25 16.6665'
              stroke='#0066FF'
              strokeWidth='3'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>

          <h3 className='text-2xl font-montserrat font-semibold text-black'>
            {dict.formSuccessTitle}
          </h3>
          <p className='text-lg font-montserrat text-black'>
            {dict.formSuccessSubtitle}
          </p>
        </div>
      </Modal>

      <form onSubmit={handleSubmit} className='space-y-6 pt-[240px]'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          <div>
            <label className='block text-base font-montserrat font-medium text-accent mb-2'>
              {dict.formName}
            </label>
            <input
              type='text'
              name='name'
              value={formData.name}
              onChange={handleInputChange}
              placeholder='John Carter'
              className={fieldBase}
              required
            />
          </div>
          <div>
            <label className='block text-base font-montserrat font-medium text-accent mb-2'>
              {dict.formEmail}
            </label>
            <input
              type='email'
              name='email'
              value={formData.email}
              onChange={handleInputChange}
              placeholder='example@email.com'
              className={fieldBase}
              required
            />
          </div>
        </div>
        <div>
          <label className='block text-base font-montserrat font-medium text-accent mb-2'>
            {dict.formPhone}
          </label>
          <input
            type='tel'
            name='phone'
            value={formData.phone}
            onChange={handleInputChange}
            placeholder='+380 (00) 000 - 00 - 00'
            className={fieldBase}
            required
          />
        </div>
        <div>
          <label className='block text-base font-montserrat font-medium text-accent mb-2'>
            {dict.formMessage}
          </label>
          <textarea
            name='message'
            value={formData.message}
            onChange={handleInputChange}
            placeholder={dict.formMessagePlaceholder}
            rows={5}
            className={`${fieldBase} resize-none`}
            required
          />
        </div>
        <div className='flex items-center space-x-3'>
          <input
            type='checkbox'
            id='consent'
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className='w-4 h-4 accent-accent bg-transparent border-2 border-white/40 rounded'
          />
          <label
            htmlFor='consent'
            className='text-sm font-montserrat text-gray-300'
          >
            {dict.formCheckbox}
          </label>

          {error && (
            <span className='text-red-400 text-sm font-montserrat'>
              {dict.formCheckboxError}
            </span>
          )}
        </div>

        <Button
          type='submit'
          className='bg-accent text-white font-montserrat font-semibold px-8 py-4 rounded-lg hover:bg-accent-dark transition-colors'
        >
          {dict.formButton}
        </Button>
      </form>
    </>
  );
}

export default ContactForm;
